import React from 'react';
import Icon from '../../../components/AppIcon';

const SuccessMetrics = ({ metrics }) => {
  return (
    <div className="bg-card rounded-lg p-4 md:p-6 lg:p-8 border border-border">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 bg-success/10 rounded-lg flex items-center justify-center">
          <Icon name="TrendingUp" size={24} color="var(--color-success)" />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground font-headline">
            Network Success Metrics
          </h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Quantified achievements across our partnership network
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {metrics?.map((metric) => (
          <div
            key={metric?.id}
            className="bg-gradient-to-br from-muted to-muted/50 rounded-lg p-4 md:p-6 hover:shadow-lg transition-all duration-300"
          >
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center ${metric?.bgColor}`}>
                  <Icon name={metric?.icon} size={20} color={metric?.iconColor} />
                </div>
                <div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground">
                    {metric?.title}
                  </h3>
                  <p className="text-xs text-muted-foreground">{metric?.category}</p>
                </div>
              </div>
              {metric?.trend && (
                <div className={`flex items-center gap-1 px-2 py-1 rounded-full ${
                  metric?.trend > 0 ? 'bg-success/10' : 'bg-error/10'
                }`}>
                  <Icon
                    name={metric?.trend > 0 ? 'ArrowUp' : 'ArrowDown'}
                    size={12}
                    color={metric?.trend > 0 ? 'var(--color-success)' : 'var(--color-error)'}
                  />
                  <span className={`text-xs font-semibold ${
                    metric?.trend > 0 ? 'text-success' : 'text-error'
                  }`}>
                    {Math.abs(metric?.trend)}%
                  </span>
                </div>
              )}
            </div>

            <div className="space-y-3">
              <div>
                <p className="text-3xl md:text-4xl font-bold text-foreground font-headline">
                  {metric?.value}
                </p>
                <p className="text-xs md:text-sm text-muted-foreground mt-1">
                  {metric?.description}
                </p>
              </div>

              {metric?.breakdown && (
                <div className="pt-3 border-t border-border space-y-2">
                  {metric?.breakdown?.map((item, index) => (
                    <div key={index} className="flex items-center justify-between">
                      <span className="text-xs md:text-sm text-muted-foreground">
                        {item?.label}
                      </span>
                      <span className="text-xs md:text-sm font-semibold text-foreground">
                        {item?.value}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuccessMetrics;